<template>
	<page>
		<module title="购买代理卡记录详情">
			<c-detail >
				<c-detail-item label="交易单号" >
					{{detailData.record_number}}
				</c-detail-item>
                <c-detail-item label="代理信息" >
                    <template v-slot="{data}">
			            <span>
			              {{detailData.user_manage_mobilephone}}
			              <span v-if="detailData.nick_name && detailData.nick_name!=''">({{detailData.nick_name}})</span>
			            </span>
                    </template>
                </c-detail-item>
                <c-detail-item label="交易金额" >
                    <template v-slot="{data}">
                        <span>￥{{(detailData.money||0).toFixed(2)}}</span>
                    </template>
                </c-detail-item>
                <c-detail-item label="购买等级" >{{detailData.level_name}}</c-detail-item>
                <c-detail-item label="升级赠品" full>
                    <span v-if="detailData.is_gift == 1">
                        <span  v-if="detailData.package_id && detailData.package_id > 0">
                            <a @click="navigateTo(`/gift_package_detail/${detailData.package_id}`)" style="color: blue">升级礼包</a>
                        </span>
                         <span v-if="detailData.gift_order_number">
                           ；礼包订单：<a @click="navigateTo(`/order_detail/${detailData.gift_order_number}`)" style="color: blue">{{detailData.gift_order_number}}</a>
                         </span>
                    </span>
                    <span v-else>无赠品</span>
                </c-detail-item>
                <c-detail-item label="交易状态" >
					<template v-slot="{data}">
						<span style="color:green" v-if="detailData.payment_state==2">已支付</span>
						<span style="color:gray" v-if="detailData.payment_state==1">待支付</span>
					</template>
				</c-detail-item>
				<c-detail-item label="支付渠道" >
					<template v-slot="{data}">
						<span v-if="detailData.payment_state==1">--</span>
						<span v-else>{{detailData.payment_type}}</span>
					</template>
				</c-detail-item>
				<c-detail-item label="第三方支付单号" >
                    <template v-slot="{data}">
                        <span v-if="detailData.third_number">{{detailData.third_number}}</span>
                        <span v-else>--</span>
                    </template>
				</c-detail-item>
				<c-detail-item label="支付时间">
                    <template v-slot="{data}">
                        <span v-if="detailData.payment_date">{{detailData.payment_date}}</span>
                        <span v-else>--</span>
                    </template>
				</c-detail-item>
				<c-detail-item label="礼包订单" v-if="detailData.is_gift==1 && detailData.gift_order_number">
                    <a @click="navigateTo(`/order_detail/${detailData.gift_order_number}`)">{{detailData.gift_order_number}}</a>
                </c-detail-item>
				<c-detail-item label="礼包订单类型" v-if="detailData.is_gift==1 && detailData.gift_order_number">
                    <span v-if="detailData.gift_is_virtual==0">虚拟订单</span>
                    <span v-else-if="detailData.gift_is_virtual==1">实物订单</span>
                </c-detail-item>
                <c-detail-item label="礼包订单收货信息" full v-if="detailData.is_gift==1 && detailData.gift_order_number && detailData.gift_is_virtual==1">
                    {{detailData.receiving_address}} {{detailData.receiving_name}} {{detailData.receiving_phone}}
                </c-detail-item>
			</c-detail>
		</module>
	</page>
</template>

<script>
	import {mapState} from "vuex";

	export default {
		name: 'm_membership_record_detail',
		props: {
			id: String
		},
		data() {
			return {
				detailData: {},
				approvalReason: ''
			}
		},
		mounted() {
			this.detail();
		},

		computed: {
			...mapState(['systemConfig'])
		},

		watch: {
			id() {
				this.detail();
			}
		},

		methods: {
			detail() {
				this.request({
					url: '/user/recharge/record/detail',
					data: {id: this.id},
					loading: true,
					success: data => {
						this.detailData = data;
					}
				});
			}
		}
	}
</script>